import React from 'react';
import './Home.css';

const Home: React.FC = () => {
  return (
    <section className="home">
      <div className="home-container">
        <div className="home-content">
          <h1 className="home-title">HELLO, I'm a Software Developer</h1>
          <p className="home-subtitle">Welcome to my personal portfolio</p>
          <p className="home-description">
            I'm passionate about creating clean, efficient, and scalable software solutions.
            Explore my work and get to know more about my skills and experience.
          </p>
          <div className="home-buttons">
            <a href="/projects" className="btn btn-primary">View Projects</a>
            <a href="/contact" className="btn btn-secondary">Get In Touch</a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Home;